import { Card, CardBody } from 'reactstrap';
import './UsageTransferMetricCard.css';
interface MetricCardProps {
  color: 'green' | 'orange';
  children: React.ReactNode;
}

const UsageTransferMetricCard = ({ color, children }: MetricCardProps) => {
  return (
    <Card className={`metric-card ${color }`}>
          <CardBody>
              <div className='metric-row'>{children}</div>
          </CardBody>
    </Card>
  );
};

export default UsageTransferMetricCard;